var utils = require('util');
var ElementView = require('./ElementView');
var PartView = require('./PartView');
var PartCache = require('../Models/PartCache');

var CompositionElementView = module.exports = function(model, numberOfParts) {
    this.init(model);

    this.initCompositionElementView(numberOfParts);

    this.initView();

    this.cache = new PartCache();
};

utils.inherits(CompositionElementView, ElementView);

CompositionElementView.prototype.initCompositionElementView = function(numberOfParts) {
    this.partViews = [];
    this.numberOfParts = numberOfParts;
};


CompositionElementView.prototype.loadModel3D = function() {
    var that = this;
    var geometry = new THREE.Object3D();
    var keys = Object.keys(that.model);
    var numberOfPartsLoaded = 0;
    var modelsPosition = that.model.position;
    var parentHeight = that.model._height;
    var parentLength = that.model._length;
    var parentDepth = that.model._depth;
    var firstLoad = true;
    var modelsRotation = that.model.rotation;
    geometry.position.set(modelsPosition[0], modelsPosition[1], modelsPosition[2]);

    geometry.rotation.set(modelsRotation[0], modelsRotation[1], modelsRotation[2]);
    var viewsToLoad = [];

    keys.forEach(function(part, key1) {
        var data = {};
        if(that.model[part] !== null && that.model[part].partType === 'PART'){
            data['key'] = part;
            viewsToLoad.push(data);
        }
        else if(Array.isArray(that.model[part]) && that.model[part].length > 0 && that.model[part][0].partType === 'PART') {
            data['key'] = part;
            data['count'] = that.model[part].length;


            viewsToLoad.push(data);
        }
    });

    addPartViews(viewsToLoad, 0, 0);

    return this;

    function addPartViews(viewsToLoad, key, index) {
        if(viewsToLoad.length > key) {
            var partType = viewsToLoad[key]['key'];

            var model = that.model[partType];
            if(Array.isArray(model)) {
                if( viewsToLoad[key]['count'] > index) {

                    model = model[index];

                    addPartView(model, partType, key, true, index);
                }else {
                    key++;
                    addPartViews(viewsToLoad, key, 0);
                }

            }else {
                addPartView(model, partType, key, false, index);
            }

        }
    }

    function addPartView(model, partType, key, increaseIndex, index) {
        var partView = PartView.factory(partType, model, parentHeight, parentLength, parentDepth);
        that.addPartView(partView);


        partView.once('3DModelLoaded', function() {
            if(partView.getModel3D() instanceof THREE.Object3D) {
                geometry.add(partView.getModel3D());
            }

            that.setModel3D(geometry);
            numberOfPartsLoaded++;
            that.cache.setCache(model.file, partView.getOriginal3DModel());

            if(numberOfPartsLoaded === that.getNumberOfParts()) {
                that.emit('3DCompositionModelLoaded');
            }

            if(increaseIndex) {
                index++;

                addPartViews(viewsToLoad, key, index);
            }else  {
                key++;
                addPartViews(viewsToLoad, key, 0);
            }
        });

        partView.loadModel3D(that.cache.getCache(model.file));
    }
};


CompositionElementView.prototype.addPartView = function(partView) {

    partView.setScalePanelOffset(this.scalePanelOffset);
    this.partViews.push(partView);

    return this;
};

CompositionElementView.prototype.getNumberOfParts = function() {
    return this.numberOfParts;
};

CompositionElementView.prototype.updateHeight = function(newHeight) {
    var that = this;

    if(that.model.isDoubleDoorRackCap) {
        that.getModel()._depth = newHeight;
        that.partViews.forEach(function(view) {
            view.updateDepth(newHeight);
        });
    }else {
        that.getModel()._height = newHeight;
        that.partViews.forEach(function(view) {
            view.updateHeight(newHeight);
        });
    }
};

CompositionElementView.prototype.scaleHeight = function(globalScale, change, keepCapBodyRatio, onCap, keepBodyHeight) {
    var that = this;

    if(that.model.isDoubleDoorRackCap) {
        that.partViews.forEach(function(view) {
            view.scaleDepth(globalScale, change);
        });
    }else {
        if(onCap && !keepBodyHeight) {
            //that.model3D.position.y *= globalScale;
            that.model3D.position.y += 0.5*change;
        }

        that.partViews.forEach(function(view) {
            view.scaleHeight(globalScale, change, keepCapBodyRatio, onCap, keepBodyHeight);
        });

    }
};

CompositionElementView.prototype.updateLength = function(newLength) {
    var that = this;

    that.getModel()._length = newLength;

    that.partViews.forEach(function(view) {
        view.updateLength(newLength);
    });
};

CompositionElementView.prototype.scaleLength = function(globalScale, change) {
    var that = this;

    if(that.model.isDoubleDoorRackCap) {
        var xPosition = that.getModel3D().position.x;
        if(xPosition < 0) {
            that.getModel3D().position.x -= 0.5*change;
        }else if(xPosition > 0) {
            that.getModel3D().position.x += 0.5*change;
        }
    }else {
        that.partViews.forEach(function(view) {
            view.scaleLength(globalScale, change);
        });
    }

};

CompositionElementView.prototype.updateDepth = function(newDepth, change) {
    var that = this;

    that.getModel()._depth = newDepth;

    that.partViews.forEach(function(view) {
        view.updateDepth(newDepth);
    });
};

CompositionElementView.prototype.scaleDepth = function(globalScale, change) {
    var that = this;

    if(that.model.isDoubleDoorRackCap) {
        var zPosition = that.getModel3D().position.z;
        if(zPosition < 0) {
            that.getModel3D().position.z -= 0.5*change;
        }else if(zPosition > 0) {
            that.getModel3D().position.z += 0.5*change;
        }
    }else {
        that.partViews.forEach(function(view) {
            view.scaleDepth(globalScale, change);
        });
    }

};


CompositionElementView.prototype.getPartViews = function() {
    return this.partViews;
};

CompositionElementView.prototype.replacePartView = function(index, newPartView) {
    var that = this;

    var partView = that.partViews[index];
    that.model3D.remove(partView.getModel3D());

    delete that.partViews[index];

    that.partViews[index] = newPartView;

    that.model3D.add(newPartView.getModel3D());
};


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Views/CompositionElementView.js